import { useCallback } from "react";

import { ClientsService, type InternalClientsListParams } from "../services/clientsService";
import type { OrganizationTreeItem } from "../types/clients-api.types";
import { usePaginatedClientsQuery, type PaginatedClientsQuery } from "./usePaginatedClientsQuery";

/**
 * Level 1 of the master-detail (internal users): paginated portfolio of organizations from GET
 * /internal/clients/tree. Client/account counters are derived from the nested arrays — the nested clients are
 * never rendered as rows (they only carry id/name/accountIds).
 *
 * Filters applied by the backend on this endpoint: `search` (org name/email) and `country`. `type` is
 * declared in the contract but not implemented in QA yet (see docs/clients-view-gaps.md).
 */
export function useOrganizationsPortfolio(): PaginatedClientsQuery<OrganizationTreeItem> {
  const fetcher = useCallback(async (params: InternalClientsListParams) => {
    const response = await ClientsService.fetchTree(params);
    return { rows: response.data.data, total: response.data.total };
  }, []);

  return usePaginatedClientsQuery(fetcher);
}
